import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SubcategoryService {

  constructor(private http: HttpClient) { }


  postSubCategory(formData){

    return this.http.post(environment.apiBaseURI + '/ProductSubCategory', formData);
    
  }
  putSubCategory(formData){
    console.log(environment.apiBaseURI + '/ProductSubCategory/' + formData.id);
    //console.log(formData);
    return this.http.put(environment.apiBaseURI + '/ProductSubCategory/', formData);
    

  }
  getSubCategoryList(param: any){
    return this.http.post(environment.apiBaseURI + '/ProductSubCategory/GetProductSubCategoryDetailsList', param);
    

  }
  getSubCategories(){
    return this.http.get(environment.apiBaseURI + '/ProductSubCategory/' );
    

  }

  deleteSubCategory(id) {
    return this.http.delete(environment.apiBaseURI + '/ProductSubCategory/' + id);
  }
}
